import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace, WorkspaceSalesOrderPhase } from '@/hooks/api/models';

/**
 * 2570. ワークスペース受注フェーズ名変更
 * [PUT] /workspaces/:identifier/workspace_sales_order_phases/:workspace_sales_order_phase_id
 */
type Props = {
  identifier: string;
  phase_id: number;
  label: string;
};
export const updateWorkspaceSalesOrderPhases = (props: Props): Promise<WorkspaceSalesOrderPhase> => {
  return axios.put(`/api/workspaces/${props.identifier}/workspace_sales_order_phases/${props.phase_id}`, props);
};

export const useUpdateWorkspaceSalesOrderPhases = () => {
  return useMutation({
    mutationFn: updateWorkspaceSalesOrderPhases,
  });
};
